import { MapaBolhas } from "@/components/mapa/MapaBolhas";
import { formatNumero, ordenarPor, type CidadeResolvida, type Metrica } from "./cidades";
import type { Variante } from "./KpiCards";

// Mesma cor do --primary (teal) para dispensações; âmbar para farmácias, para as
// duas métricas não se confundirem quando o usuário alterna.
const COR: Record<Metrica, string> = {
  dispensacoes: "#0d9488",
  farmacias: "#d97706",
};

interface MapaCidadesProps {
  cidades: CidadeResolvida[];
  metrica: Metrica;
  variante?: Variante;
  /** Modo TV: rótulo fixo nas N maiores cidades (não há mouse para o tooltip). */
  rotulosFixos?: number;
}

export function MapaCidades({ cidades, metrica, variante = "padrao", rotulosFixos = 0 }: MapaCidadesProps) {
  const pontos = ordenarPor(cidades, metrica).map((cidade) => ({
    chave: `${metrica}-${cidade.codigoIbge}`,
    lat: cidade.lat,
    lng: cidade.lng,
    valor: cidade[metrica],
    tooltip: (
      <>
        <strong>
          {cidade.nome}/{cidade.uf}
        </strong>
        <br />
        {formatNumero(cidade.dispensacoes)} dispensações · {formatNumero(cidade.farmacias)} farmácias cadastradas
        {cidade.cnpjsDispensando > 0 && (
          <>
            <br />
            {formatNumero(cidade.cnpjsDispensando)} CNPJ(s) dispensando
          </>
        )}
      </>
    ),
  }));

  return <MapaBolhas pontos={pontos} cor={COR[metrica]} variante={variante} rotulosFixos={rotulosFixos} />;
}
